import { render, staticRenderFns } from "./ListSeguroiparcelamentoPage.vue?vue&type=template&id=45263205"
import script from "./ListSeguroiparcelamentoPage.vue?vue&type=script&lang=js"
export * from "./ListSeguroiparcelamentoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports